var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "200px",
    width: "200px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D9BEB"
    },
    d: "M0,256.006C0,397.402,114.606,512.004,255.996,512C397.394,512.004,512,397.402,512,256.006 C512.009,114.61,397.394,0,255.996,0C114.606,0,0,114.614,0,256.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4988DB"
    },
    d: "M507.518,303.58L295.574,91.636c-0.636-0.637-1.394-1.146-2.238-1.498 c-0.837-0.35-1.742-0.539-2.67-0.539H138.133c-3.833,0-6.933,3.105-6.933,6.933v318.933c0,2.348,1.242,4.32,3.027,5.574 c0.462,0.657,87.758,87.953,88.415,88.416c0.098,0.14,0.249,0.225,0.355,0.355c10.811,1.392,21.809,2.188,32.998,2.188 C381.13,512.003,485.212,422.226,507.518,303.58z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F6F9"
    },
    d: "M380.262,177.066c-0.352-0.844-0.861-1.603-1.498-2.239l-83.189-83.189 c-0.635-0.637-1.394-1.146-2.238-1.498c-0.838-0.351-1.743-0.54-2.671-0.54H138.133c-3.833,0-6.933,3.104-6.933,6.933v318.933 c0,3.829,3.101,6.933,6.933,6.933h235.733c3.833,0,6.933-3.104,6.933-6.933V179.733C380.8,178.809,380.611,177.904,380.262,177.066 z M297.6,113.27l59.53,59.53H297.6V113.27z M145.067,408.533V103.467h138.667v76.267c0,3.829,3.101,6.933,6.933,6.933h76.267 v221.867H145.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F6F9"
    },
    d: "M332.267,200.533H179.733c-3.833,0-6.933,3.104-6.933,6.933v166.4c0,3.829,3.101,6.933,6.933,6.933 h152.533c3.833,0,6.933-3.104,6.933-6.933v-166.4C339.2,203.637,336.099,200.533,332.267,200.533z M228.267,325.333V297.6h55.467 v27.733H228.267z M283.733,339.2v27.733h-55.467V339.2H283.733z M283.733,256v27.733h-55.467V256H283.733z M228.267,242.133V214.4 h55.467v27.733H228.267z M297.6,256h27.733v27.733H297.6V256z M214.4,283.733h-27.733V256H214.4V283.733z M186.667,297.6H214.4 v27.733h-27.733V297.6z M297.6,297.6h27.733v27.733H297.6V297.6z M325.333,242.133H297.6V214.4h27.733V242.133z M214.4,214.4 v27.733h-27.733V214.4H214.4z M186.667,339.2H214.4v27.733h-27.733V339.2z M297.6,366.933V339.2h27.733v27.733H297.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.cde024057fbee6a9cb1e20a06f103d02.svg";
export { ForwardRef as ReactComponent };